export default "__VITE_ASSET__hQH82JcS__"